import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ArrowDown, ArrowUp } from '@origo_vl_banking/icons';

const Wrapper = styled.div`
  padding-top: 6px;
`;

const Button = styled.button`
  cursor: pointer;
  border: 0;
  margin: 0;
  background: 0;
  text-decoration: none;
  outline: 0;
  display: flex;
  align-items: center;

  :focus {
    text-decoration: underline;
  }
`;

const ButtonText = styled.span`
  font-size: 18px;
  color: ${({ color, theme }) => color || theme.buttonPrimary};
  margin-right: 10px;
`;

const DetailsButton = ({
  showDetails, onClick, buttonStyle, content, color, tabIndex,
}) => (
  <Wrapper>
    <Button style={buttonStyle} onClick={onClick} tabIndex={tabIndex}>
      <ButtonText color={color}>{content}</ButtonText>
      {showDetails ? <ArrowUp size={24} /> : <ArrowDown size={24} />}
    </Button>
  </Wrapper>
);

DetailsButton.propTypes = {
  buttonStyle: PropTypes.object,
  color: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onClick: PropTypes.func,
  showDetails: PropTypes.bool.isRequired,
  tabIndex: PropTypes.string,
};

DetailsButton.defaultProps = {
  buttonStyle: null,
  color: null,
  content: '',
  onClick: () => null,
  tabIndex: null,
};

export default DetailsButton;
